<template>
  <!-- 卡片视图 -->
  <div class="boxHeight" v-loading="loading">
    <el-card>
      <!-- 搜索-->
      <el-row :gutter="20" type="flex" justify="space-between">
        <el-col>
          <el-button plain class="add-column-btn bbox" @click="gotoDetail(null)" type="primary">
            <i class="el-icon-plus fw900 f16"></i> 新增</el-button>
          <!-- <el-button plain class="add-column-btn bbox" @click="deleteBatch()" type="primary">
            <i class="el-icon-minus fw900 f16"></i> 删除</el-button> -->
          <el-button plain class="add-column-btn bbox" @click="downCode" type="primary">
            <i class="el-icon-download fw900 f16"></i> 下载桌台码</el-button>
          <el-button plain class="add-column-btn bbox" @click="showSortDialog" type="primary">
            桌台排序</el-button>
        </el-col>
        <el-col>
          <div class="flex align-center justify-end header-search-box">
            <el-input placeholder="查询条件" clearable v-model="searchInput" class="header-search-input ml10"
              style="width: 300px">
              <el-button slot="append" icon="el-icon-search" class="textblue searchBtn" @click="search()"></el-button>
            </el-input>
          </div>
        </el-col>
      </el-row>
      <div class="twoSide">
        <div class="left">
          <div @click="searchByCode(item)" :class="{ item: true, active: item.tableAreaCode == activeItem }"
            v-for="(item, index) in areaList" :key="index">
            {{ item.tableAreaName }}
          </div>
        </div>
        <div>
          <el-table ref="tableRef" :row-key="getRowId" toggleRowSelection :data="tableData" border fit height="100%"
            highlight-current-row style="width: calc(100% - 10px)" @sort-change="sortChange"
            @selection-change="handleSelectionChange">
            <!-- <el-table-column type="selection" width="55" align="center" :reserve-selection="true"></el-table-column> -->
            <el-table-column type="index" label="序号" align="center"></el-table-column>
            <!-- <el-table-column label="商家名称" align="center" prop="商家名称">
                <template slot-scope="scope">
                  <span>{{ scope.row.merchantName }}</span>
                </template>
</el-table-column> -->
            <el-table-column label="桌台名称" align="center" prop="桌台名称">
              <template slot-scope="scope">
                <span>{{ scope.row.tableName }}</span>
              </template>
            </el-table-column>

            <el-table-column label="桌台区域名称" align="center" prop="桌台区域名称">
              <template slot-scope="scope">
                <span>{{ scope.row.tableAreaName }}</span>
              </template>
            </el-table-column>
            <el-table-column label="桌台状态" align="center" prop="桌台状态">
              <template slot-scope="scope">
                <span v-if="
                  scope.row.tableStatus == 'free' ||
                  scope.row.tableStatus == 'open'
                " style="color: green">空闲</span>
                <span v-if="scope.row.tableStatus == 'used'" style="color: #f40">非空闲</span>
              </template>
            </el-table-column>
            <el-table-column label="人数" align="center" prop="人数">
              <template slot-scope="scope">
                <span>{{ scope.row.allowPeople }}</span>
              </template>
            </el-table-column>
            <el-table-column label="用餐金额" align="center" prop="当前应付金额">
              <template slot-scope="scope">
                <span>{{ scope.row.currSumToPay }}</span>
              </template>
            </el-table-column>
            <el-table-column label="开台时间" align="center" prop="开台时间">
              <template slot-scope="scope">
                <span>{{ scope.row.openDt | dataFormat }}</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center" class-name="small-padding fixed-width">
              <template slot-scope="scope">
                <el-tooltip class="item" effect="dark" content="编辑" placement="bottom">
                  <i class="el-icon-edit orange f16" @click="gotoDetail(scope.row.id, scope.row.userCode)"></i>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" content="删除" placement="bottom">
                  <i class="el-icon-delete orange f16 ml20" @click="del(scope.row.tableCode)"></i>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>

          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page.sync="queryInfo.currPage" :page-sizes="[10, 20, 30, 50]" :page-size="queryInfo.pageSize"
            layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
        </div>
      </div>
    </el-card>
    <el-dialog :title="title" :visible.sync="dialogFormVisible" width="600px" center>
      <el-form label-width="130px" :model="form" :rules="rules" ref="form" style="width: 100%; padding: 0 40px 0 80px">
        <el-form-item label="桌台区域" required>
          <el-select v-model="tableArea" filterable style="width: 220px" value-key="tableAreaCode" clearable
            placeholder="">
            <el-option v-for="item in areaList" :key="item.tableAreaCode" :label="item.tableAreaName" :value="{
              tableAreaCode: item.tableAreaCode,
              tableAreaName: item.tableAreaName
            }"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="桌台名称" prop="tableName" required :show-message="false">
          <el-input style="width: 220px" placeholder="" v-model="form.tableName"></el-input>
        </el-form-item>
        <el-form-item label="桌台人数" prop="allowPeople" required>
          <el-input @keyup.native.enter="save" style="width: 220px" v-model.number="form.allowPeople"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="save">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="区域排序" :visible.sync="sortDialogVisible" width="700px" :close-on-click-modal="false">
      <el-form label-width="80px" label-position="left">
        <el-form-item label="桌台区域" required>
          <el-select v-model="tableArea1" filterable value-key="tableAreaCode" clearable placeholder=""
            @change="selectArea" style="width: 200px">
            <el-option v-for="item in areaList1" :key="item.tableAreaCode" :label="item.tableAreaName" :value="{
              tableAreaCode: item.tableAreaCode,
              tableAreaName: item.tableAreaName
            }"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <el-table :data="tableData1" height="250" border style="width: 100%" v-loading="loading1">
        <el-table-column prop="tableName" label="桌台名称"> </el-table-column>
        <el-table-column prop="" label="当前排序">
          <template slot-scope="scope">
            <!-- @blur="changeSort(scope.row)" -->
            <el-select v-model="scope.row.seq" filterable placeholder="请选择" @change="changeSort(scope.row)">
              <el-option v-for="item in sortOptions" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
            <!-- <el-input v-model="scope.row.seq" @change="changeSort(scope.row)"></el-input> -->
          </template>
        </el-table-column>
      </el-table>
      <div class="footerBox">
        <!-- 分页区域 -->
        <el-pagination @size-change="handleSizeChange1" @current-change="handleCurrentChange1"
          :current-page.sync="queryInfo1.currPage" :page-sizes="[10, 20, 30, 50]" :page-size="queryInfo1.pageSize"
          layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      CurrentId: null,
      title: "新增",
      dialogFormVisible: false,
      tableArea: [],
      tableArea1: [],
      form: {
        merchantName: localStorage.getItem("merchantName"),
        merchantCode: localStorage.getItem("merchantCode"),
        tableName: "",
        allowPeople: 1
      },
      rules: {
        tableName: [
          {
            required: true,
            message: "请输入桌台名称",
            trigger: ["blur", "change"]
          }
        ],
        allowPeople: [
          {
            required: true,
            message: "请输入桌台人数",
            trigger: ["blur", "change"]
          },
          { type: "number", message: "请填入数字值" }
        ]
      },
      sortDialogVisible: false,
      sortOptions: [],
      activeItem: "",
      userSelected: [], //用户选中
      height: window.innerHeight - 256, //表格高度
      value: "",
      searchInput: "",
      tableData: [],
      tableData1: [],
      loading: true,
      loading1: true,
      // 获取用户列表查询参数对象
      queryInfo: {
        // 当前页数
        currPage: 1,
        // 每页显示多少数据
        pageSize: 20,
        //查询条件
        condition: {
          merchantCode: localStorage.getItem("merchantCode")
        }
      },
      // 弹框查询条件
      queryInfo1: {
        // 当前页数
        currPage: 1,
        // 每页显示多少数据
        pageSize: 20,
        //查询条件
        condition: {
          merchantCode: localStorage.getItem("merchantCode")
        }
      },
      areaList: [], //桌台区域
      areaList1: [], //桌台区域
      userlist: [],
      total: 0
    };
  },
  created() {
    this.getListData();
    this.getArea();
  },
  mounted() {
    this.loading = false;
  },

  methods: {
    showSortDialog() {
      this.sortDialogVisible = true;
      this.getListData1();
    },
    async changeSort(row) {
      console.log(row, "行");
      console.log(row, "修改1");
      let data = {
        id: row.id,
        seq: row.seq
      };
      // return
      const res = await this.$http.post(
        "merchantArea/updateMerchantAreaSeqByPC",
        data
      );
      console.log(res, "--修改排序");
      this.getListData();
      this.getListData1();
    },
    selectArea() {
      console.log(this.tableArea1, "选择");
      // this.queryInfo1.condition.tableAreaCode = this.tableArea1.tableAreaCode

      this.getListData1();
    },
    //唯一标识用于多选回显
    getRowId(row) {
      return row.id;
    },
    //条件查询
    search() {
      this.queryInfo.condition.id = this.searchInput;
      this.getListData();
    },
    // 监听 pagesize改变的事件
    handleSizeChange(newSize) {
      this.queryInfo.pageSize = newSize;
      this.getListData();
    },
    // 监听 页码值 改变事件
    handleCurrentChange(newSize) {
      this.queryInfo.currPage = newSize;
      this.getListData();
    },
    // 监听 pagesize改变的事件
    handleSizeChange1(newSize) {
      this.queryInfo1.pageSize = newSize;
      this.getListData1();
    },
    // 监听 页码值 改变事件
    handleCurrentChange1(newSize) {
      this.queryInfo1.currPage = newSize;
      this.getListData1();
    },

    // 监听排序
    sortChange() { },
    //跳转到详情
    gotoDetail(id) {
      var that = this;
      // this.$router.push({
      //   path: "/merchantArea/details",
      //   query: {
      //     id: id,
      //   }
      // });
      if (id) {
        this.CurrentId = id;
        this.title = "编辑";
        this.queryOne({ id });
      } else {
        this.CurrentId = null;
        this.form = {
          merchantName: localStorage.getItem("merchantName"),
          merchantCode: localStorage.getItem("merchantCode"),
          tableName: "",
          allowPeople: 1
        };
        this.title = "新增";
      }
      this.dialogFormVisible = true;
    },
    async queryOne(data) {
      let ress = await this.$http.post("/merchantAreas/queryOne", data);
      let res = ress.data.data;
      this.form.allowPeople = res.allowPeople;
      this.form.tableName = res.tableName;
      this.$set(this, "tableArea", {
        tableAreaCode: res.tableAreaCode,
        tableAreaName: res.tableAreaName
      });
    },
    async save() {
      if (this.tableArea == "") {
        this.$message.error("请选择桌台区域");
        return;
      }
      if (this.form.tableName == "") {
        this.$message.error("请输入桌台名称");
        return;
      }
      if (this.form.allowPeople < 1) {
        this.$message.error("请输入合适的桌台人数");
        return;
      }

      let data = {};
      data = this.form;
      data.tableAreaName = this.tableArea.tableAreaName;
      data.tableAreaCode = this.tableArea.tableAreaCode;
      // this.isSubmit = true
      if (this.CurrentId) {
        data.id = this.CurrentId;
      }
      let res = await this.$http.post(
        "merchantArea/saveMerchantAreaByPC",
        data
      );
      // this.isSubmit = false
      if (res.data.code == 200) {
        this.$notify({
          title: "提示",
          message: "保存成功",
          type: "success",
          duration: 1500
        });
        this.dialogFormVisible = false;
        this.form = {
          merchantName: localStorage.getItem("merchantName"),
          merchantCode: localStorage.getItem("merchantCode"),
          tableName: "",
          allowPeople: 1
        };
        this.getListData();
      } else {
        this.$notify({
          title: "提示",
          message: "保存失败",
          type: "error",
          duration: 1500
        });
      }
    },

    // 删除用户
    async del(tableCode) {
      const confirmResult = await this.$confirm("确定删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).catch(err => err);
      if (confirmResult === "confirm") {
        var that = this;
        that.$http
          .post("merchantArea/deleteMerchantArea", {
            tableCode,
            merchantCode: localStorage.getItem("merchantCode")
          })
          .then(function (response) {
            that.$notify.success({
              title: "提示",
              message: "删除成功",
              showClose: true
            });
            that.getListData();
          });
      }
    },
    getListData() {
      // 获取列表
      var that = this;
      this.loading = true;
      that.$http
        .post("/merchantAreas/list", that.queryInfo)
        .then(function (response) {
          console.log(response.data.data);
          if (response.data.code == 200) {
            that.total = response.data.data.count;
            that.queryInfo.currPage = response.data.data.currPage;
            that.tableData = response.data.data.data;
            that.loading = false;
          } else {
            that.$notify.error({
              title: "提示",
              message: response.data.message,
              showClose: true
            });
            that.loading = false;
          }
        });
    },
    getListData1() {
      // 获取列表
      var that = this;
      this.loading1 = true;
      if (this.tableArea1.tableAreaCode != "") {
        this.queryInfo1.condition.tableAreaCode = this.tableArea1.tableAreaCode;
      } else {
        delete this.queryInfo1.condition.tableAreaCode;
        return;
      }
      that.$http
        .post("/merchantAreas/list", that.queryInfo1)
        .then(function (response) {
          console.log(response.data.data);
          if (response.data.code == 200) {
            that.total = response.data.data.count;
            that.queryInfo1.currPage = response.data.data.currPage;
            that.tableData1 = response.data.data.data;
            if (that.total !== 0) {
              that.sortOptions = [];
              for (let i = 1; i <= that.total; i++) {
                that.sortOptions.push({
                  label: i,
                  value: i
                });
              }
            }
            that.loading1 = false;
          } else {
            that.$notify.error({
              title: "提示",
              message: response.data.message,
              showClose: true
            });
            that.loading1 = false;
          }
        });
    },
    //获取桌台区域
    async getArea() {
      let res = await this.$http.post("merchantAreaClass/queryList", {
        merchantCode: localStorage.getItem("merchantCode")
      });
      const data = res.data.data;

      // 1. 添加 "全部" 选项到 leftMenu
      this.areaList = [
        { tableAreaCode: "", tableAreaName: "全部" }, // 添加 "全部" 选项
        ...data // 使用解构语法，避免直接修改原数组
      ];

      // 2. 处理 leftMenu1
      this.areaList1 = data; // 从第二个元素开始复制数组，替代 shift()

      // 3. 设置 tableArea1
      if (this.areaList1.length > 0) {
        this.tableArea1 = {
          tableAreaCode: this.areaList1[0].tableAreaCode,
          tableAreaName: this.areaList1[0].tableAreaName
        };
      }
    },
    searchByCode(item) {
      this.activeItem = item.tableAreaCode;
      if (item.tableAreaCode != "") {
        this.queryInfo.condition.tableAreaCode = item.tableAreaCode;
        this.tableArea1 = {
          tableAreaCode: item.tableAreaCode,
          tableAreaName: item.tableAreaName
        };
      } else {
        delete this.queryInfo.condition.tableAreaCode;
      }

      this.getListData();
    },
    //批量删除数据
    async deleteBatch() {
      const confirmResult = await this.$confirm("确定删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).catch(err => err);
      if (confirmResult === "confirm") {
        var that = this;
        let arr = [];
        that.userSelected.forEach(item => {
          arr.push(item.id);
        });
        console.log(arr, "传参");
        that.$http
          .post("/merchantAreas/deleteMerchantAreaBatch", arr)
          .then(function (response) {
            if (response.data.code == 200) {
              that.$notify.success({
                title: "提示",
                message: "删除成功",
                showClose: true
              });
              that.$refs.tableRef.clearSelection();
            } else {
              that.$message.error("删除失败");
            }
            that.getListData();
          });
      }
    },
    //多选
    handleSelectionChange(val) {
      this.userSelected = val;
    },
    downCode() {
      if (this.userSelected.length == 0) {
        this.$message({ type: "warning", message: "请选择要下载的列表" });
        return;
      }
      var idList = [];
      this.userSelected.forEach(item => {
        idList.push(item.id);
        console.log(item);
      });
      console.log(idList, "idList");
      console.log({ merchantCode: localStorage.getItem("merchantCode") });
      this.$http
        .post("/merchantAreas/downloadZip", {
          merchantCode: localStorage.getItem("merchantCode"),
          idList
        })
        .then(res => {
          console.log(res);
          if (res.data.code == 200) {
            var link = document.createElement("a");
            link.href = res.data.data;
            link.download = "桌台码.zip";
            // link.click()
            window.open(res.data.data);
          } else {
            this.$message.error(res.data.message);
          }
        });
    }
  }
};
</script>

<style lang="less" scoped>
.textblue {
  color: #008eff;
}

.orange {
  color: #f59a23;
}

.managingPeople {
  .el-card {
    height: calc(100vh - 114px);
    position: relative;

    .el-select>.el-input {
      width: 200px;
    }

    .header-search-box .header-search-input {
      width: 325px;
    }

    input::placeholder {
      font-size: 12px;
    }

    .handle-btn .el-button.add-column-btn {
      width: 100%;
      font-size: 13px;
      background-color: transparent;
      color: #008eff;
      z-index: 102;
    }

    .footerBox {
      position: absolute;
      width: 100%;
      height: 78px;
      left: 20px;
      right: 20px;
      bottom: 0;
    }
  }
}

.twoSide {
  display: flex;
  margin-top: 20px;


  .left {
    width: 110px;
    height: 100%;
    padding-right: 14px;
    scroll-behavior: smooth;

    .item {
      user-select: none;
      display: flex;
      align-items: center;
      justify-content: left;
      height: 32px;
      padding-left: 4px;
      width: 106px;
      margin-bottom: 6px;
      color: #666;
      font-size: 14px;
      cursor: pointer;
    }

    .active {
      background: #fff3bf;
    }
  }

  .right {
    margin-left: 12px;
    display: flex;
    flex: 1;
    height: 100%;
    position: relative;

    // .el-pagination {
    //   position: absolute;
    //   bottom: 0;
    // }

    >div {
      width: 100%;
    }
  }
}

/deep/ .el-table.el-table--border {
  margin-top: 0;
}

/deep/ .el-card {
  height: calc(100vh - 79px);
  // background: red;
}

/deep/ .el-card__body {
  height: 100%;
  box-sizing: border-box;
}

/deep/ .el-button {
  background: #f59a23;
  color: #fff;
  border-color: #f59a23;
}

/deep/ .el-button:hover {
  background: #f59a23;
  color: #fff;
  border-color: #f59a23;
}
</style>
